import { render, staticRenderFns } from "./PortfolioAdd.vue?vue&type=template&id=0dba51c9&"
import script from "./PortfolioAdd.vue?vue&type=script&lang=js&"
export * from "./PortfolioAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports